import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * API URL Interceptor
 * 
 * Prepends the API base URL from environment configuration to all API requests.
 * This ensures that in production, requests go to the correct backend server
 * instead of being relative to the current domain.
 * 
 * @param req - The outgoing HTTP request
 * @param next - The next handler in the interceptor chain
 */
export const apiUrlInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    // Only modify requests that start with 'api/' or '/api'
    // Don't modify absolute URLs (http://, https://, //)
    if (req.url.startsWith('api/') || req.url.startsWith('/api')) {
        // Remove leading slash if present
        const url = req.url.startsWith('/') ? req.url.substring(1) : req.url;

        // Clone the request with the full API URL
        const apiReq = req.clone({
            url: `${environment.apiUrl}/${url}`
        });

        return next(apiReq);
    }

    // Pass through all other requests unchanged
    return next(req);
};
